/**
 * Reset the keys on an array
 */
export default function resetKeys <T> ( array: T[] ): T[] {
    return array.filter( ( item: T ): boolean => item !== undefined )
}
